module.exports = __webpack_public_path__ + "img/noi-program-3.fbcdf1b6.jpg";